import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {DynamicZyxDaemonService} from '../../components/dynamic-xyz/dynamic-zyx-daemon.service';

@Component({
    selector:        'dex-tx-history-widget',
    templateUrl:     './dex-tx-history-widget.component.html',
    styleUrl:        './dex-tx-history-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class DexTxHistoryWidgetComponent {

    public readonly dynamicZyxDaemonService = inject(DynamicZyxDaemonService);

}
